import styled from 'styled-components';

export const StyledHeaderPlaceholder = styled.div`
  height: 64px;
  width: 100%;
`;

export const StyledTopBar = styled.div`
  width: 100%;
  position: sticky;
  top: 0;
  right: 0;
  padding-left: 64px;
  z-index: 2;

  .application-header {
    background-color: #fff;
    height: 64px;
    box-shadow: 0 2px 4px 0 rgba(24, 50, 71, 0.08);
    background-color: #ffffff;
    vertical-align: middle;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    // padding-bottom: 5px;
    &.hellobar {
      .adjtop {
        padding-top: 3px !important;
      }
    }

    &.notification {
      .adjtop {
        padding-top: 2px !important;
      }
    }
  }
  .right {
    display: flex;
    align-items: center;
  }

  .announcement-mount {
    margin-left: 12px;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: opacity 150ms linear;

    &:hover {
      opacity: 0.8;
    }

    .beamer_icon.active,
    #beamerIcon.active {
      top: -7px;
      left: 12px;
    }
  }
`;

export const HelloBar = styled.div`
  /* display: none; */
  width: 100%;
  background: #11244a;
  padding: 3px 0;
  text-align: center;
  color: #fff;
  font-size: 12px;

  b {
    font-weight: bold;
  }

  &.notification {
    background: #f6f8fa;
    color: #615f97;
    padding: 4px 0;
    font-size: 13px;
  }
`;

export const StyledBreadcrumb = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.85;
  padding-left: 20px;
  /* text-transform: capitalize; */
  color: var(--base-color);
  display: flex;

  .breadcrumb-separator {
    padding: 0 8px;
  }
  .leaf-node {
    font-weight: 500;
    cursor: default;
  }

  .homelink {
    max-width: 140px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    &:hover {
      border-bottom: 1px solid #283da5;
    }
  }
`;
